import React from 'react';
import PropTypes from 'prop-types';

import { mergeClasses } from '@utils';

export default function MembershipUSP({ className, children, ...restProps }) {
  return (
    <li
      className={mergeClasses(
        'flex items-start gap-2 text-base font-semibold text-black',
        className
      )}
      {...restProps}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-6 w-6 shrink-0 text-black"
      >
        <path d="M20 6 9 17l-5-5" />
      </svg>
      <span>{children}</span>
    </li>
  );
}

MembershipUSP.propTypes = {
  className: PropTypes.string,
  children: PropTypes.string.isRequired
};

MembershipUSP.defaultProps = {
  className: ''
};
